import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { FaArrowLeft, FaArrowRight, FaTimes } from 'react-icons/fa'

const images = [
  {
    src: '/images/portfolio/project-1.webp',
    alt: 'Produção de portão basculante',
    category: 'Portões',
  },
  {
    src: '/images/portfolio/project-2.webp',
    alt: 'Estrutura metálica para cobertura',
    category: 'Estruturas',
  },
  {
    src: '/images/portfolio/project-3.webp',
    alt: 'Gradil fabricado para Prefeitura Municipal',
    category: 'Gradis',
  },
  {
    src: '/images/portfolio/project-4.webp',
    alt: 'Portão basculante modelo brise',
    category: 'Portões',
  },
  {
    src: '/images/portfolio/project-5.webp',
    alt: 'Portão basculante modelo fechado',
    category: 'Portões',
  },
  {
    src: '/images/portfolio/project-6.webp',
    alt: 'Portões basculantes entregues para CPM Construtora & Incorporadora',
    category: 'Portões',
  },
]

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null)

  const handlePrevious = () => {
    setSelectedImage((current) =>
      current === 0 ? images.length - 1 : current! - 1
    )
  }

  const handleNext = () => {
    setSelectedImage((current) =>
      current === images.length - 1 ? 0 : current! + 1
    )
  }

  const handleKeyDown = (e: KeyboardEvent) => {
    if (selectedImage === null) return
    if (e.key === 'ArrowLeft') handlePrevious()
    if (e.key === 'ArrowRight') handleNext()
    if (e.key === 'Escape') setSelectedImage(null)
  }

  return (
    <>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {images.map((image, index) => (
          <motion.div
            key={image.src}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="group relative aspect-video cursor-pointer overflow-hidden rounded-lg"
            onClick={() => setSelectedImage(index)}
          >
            <img
              src={image.src}
              alt={image.alt}
              className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              <div className="absolute bottom-0 w-full p-4">
                <p className="text-sm font-medium text-white">{image.category}</p>
                <h3 className="text-lg font-semibold text-white">{image.alt}</h3>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <AnimatePresence>
        {selectedImage !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button
              className="absolute right-4 top-4 text-white hover:text-gray-300"
              onClick={() => setSelectedImage(null)}
            >
              <FaTimes className="h-6 w-6" />
            </button>

            <button
              className="absolute left-4 text-white hover:text-gray-300"
              onClick={(e) => {
                e.stopPropagation()
                handlePrevious()
              }}
            >
              <FaArrowLeft className="h-6 w-6" />
            </button>

            <div
              className="relative max-h-[90vh] max-w-[90vw]"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={images[selectedImage].src}
                alt={images[selectedImage].alt}
                className="max-h-[90vh] max-w-[90vw] object-contain"
              />
              <div className="absolute bottom-0 w-full bg-black/50 p-4 text-center">
                <p className="text-sm font-medium text-white">
                  {images[selectedImage].category}
                </p>
                <h3 className="text-lg font-semibold text-white">
                  {images[selectedImage].alt}
                </h3>
              </div>
            </div>

            <button
              className="absolute right-4 text-white hover:text-gray-300"
              onClick={(e) => {
                e.stopPropagation()
                handleNext()
              }}
            >
              <FaArrowRight className="h-6 w-6" />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
} 